<template>
  <section>
    <r-title>{{ $t("title") | titlecase }}</r-title>

    <ProcessStepBox
      :step="1"
      :active-step="step"
      :loading="!newTasks"
      selectable
      :title="$t('download.title') | titlecase"
    >
      <p v-if="!newTasks">{{ $t("download.is-loading") }}</p>
      <template v-else-if="newTasks.length">
        <p>{{ $t("download.prompt") }}</p>
        <table class="table">
          <thead>
            <tr>
              <th colspan="2">
                {{ $t(".task.doc1", { count: newTasks.length }) | titlecase }}
              </th>
              <th colspan="2">
                {{ $t(".task.doc2", { count: newTasks.length }) | titlecase }}
              </th>
              <th colspan="2">
                {{ $t(".task.doc3", { count: newTasks.length }) | titlecase }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="task in newTasks" :key="task.taskId">
              <td class="is-breakable">{{ task.file1Name }}</td>
              <td>
                <r-button prominent size="small" @click="downloadFile(task, 0)">
                  {{ $t("download.button") }}
                </r-button>
              </td>
              <td class="is-breakable">{{ task.file2Name }}</td>
              <td>
                <r-button prominent size="small" @click="downloadFile(task, 1)">
                  {{ $t("download.button") }}
                </r-button>
              </td>
              <td class="is-breakable">{{ task.file3Name }}</td>
              <td>
                <r-button
                  v-if="task.file3Name"
                  prominent
                  size="small"
                  @click="downloadFile(task, 2)"
                >
                  {{ $t("download.button") }}
                </r-button>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <p v-else>{{ $t("download.is-empty") }}</p>
    </ProcessStepBox>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import { ProcessStepBox } from "@apphq/vue-base-components";

export default {
  name: "TaskReceivePage",
  components: {
    ProcessStepBox
  },
  i18nOptions: {
    keyPrefix: "views.task-receive"
  },
  data() {
    return {
      step: 1
    };
  },
  computed: {
    ...mapGetters(["newTasks"])
  },
  beforeCreate() {
    this.$store.dispatch("loadNewTasks");
  },
  methods: {
    downloadFile(task, fileIdx) {
      this.$store.dispatch("downloadNewTaskFile", {
        task,
        fileIdx: fileIdx
      });
    }
  }
};
</script>

<style lang="scss">
@import "~@apphq/rhenus-design-base/sass/variables.scss";
@import "~bulma/sass/elements/table.sass";
@import "~bulma/sass/components/level.sass";
</style>

<style lang="scss" scoped>
.table td {
  vertical-align: middle;
}
</style>
